export enum VIEW_TYPE {
  tree = 'tree',
  flat = 'flat',
}

export enum STOCK_VIEW_TYPE {
  sold = 'sold',
  all = 'all',
}
